import React, { useState } from "react";
import { Menu, MenuItem, IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

interface Option {
  _id: string; // Changed from id to _id
  title: string;
  referenceCode: string;
  maxGroupSize: string;
  isPrivateActivity: boolean;
  cutOffTime: string;
}

interface OptionsListProps {
  options: Option[];
  onEditOption: (optionId: string) => void; // Changed type to string
  onDeleteOption: (optionId: string) => void; // Changed type to string
}

const OptionsList: React.FC<OptionsListProps> = ({
  options,
  onEditOption,
  onDeleteOption,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedOptionId, setSelectedOptionId] = useState<string | null>(null); // Changed type to string
  const open = Boolean(anchorEl);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    optionId: string // Changed type to string
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedOptionId(optionId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedOptionId(null);
  };

  const handleDelete = () => {
    if (selectedOptionId !== null) {
      onDeleteOption(selectedOptionId);
    }
    handleMenuClose();
  };

  return (
    <div className="space-y-4 mb-6">
      {options.map((option) => (
        <div
          key={option._id}
          className="border border-gray-300 p-4 rounded-lg flex flex-col-reverse gap-4 lg:flex-row justify-between lg:items-start"
        >
          <div className="font-semibold space-y-4">
            <p className="flex gap-4 text-wrap break-words flex-wrap">
              Title: <span className="text-black">{option.title}</span>
            </p>
            <p className="flex gap-4 text-wrap break-words flex-wrap">
              Reference Code:{" "}
              <span className="text-black">{option.referenceCode}</span>
            </p>
            <p className="flex gap-4 text-wrap break-words flex-wrap">
              OptionId:
              <span className="text-black">{option._id}</span>{" "}
              {/* Changed from id to _id */}
            </p>
            <p className="flex gap-4 text-wrap break-words flex-wrap">
              Cut-off time:{" "}
              <span className="text-black">{option.cutOffTime}</span>
            </p>
            <p className="flex gap-4 text-wrap break-words flex-wrap">
              Group Size:{" "}
              <span className="text-black">{option.maxGroupSize}</span>
            </p>
            <p className="flex gap-4 text-wrap break-words flex-wrap">
              Type:{" "}
              <span className="text-black">
                {option.isPrivateActivity ? "Private" : "Non-Private"}
              </span>
            </p>
          </div>
          <div className="flex justify-end w-full lg:items-center gap-2">
            <button
              className="font-bold flex items-center gap-2 cursor-pointer text-primary1 py-2 px-4 border-primary1 border rounded-lg"
              onClick={() => onEditOption(option._id)} // Changed from id to _id
            >
              Edit option
            </button>
            <IconButton
              aria-label="more"
              aria-controls={`menu-${option._id}`} // Changed from id to _id
              aria-haspopup="true"
              onClick={(event) => handleMenuClick(event, option._id)} // Changed from id to _id
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id={`menu-${option._id}`} // Changed from id to _id
              anchorEl={anchorEl}
              open={open && selectedOptionId === option._id} // Changed from id to _id
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleDelete}>Delete option</MenuItem>
            </Menu>
          </div>
        </div>
      ))}
    </div>
  );
};

export default OptionsList;
